﻿import definitions from '../Style/LfStyleDefinitions';

export default class StickyElementHandler {
    constructor() {
        this.stickySl = '[data-lf-position-sticky]';
        this.stickyActiveAttr = 'data-lf-is-sticky';
        
        this.enableStickyAtElAttr = 'data-lf-position-sticky-start-at-el';
        this.disableStickyAtElAttr = 'data-lf-position-sticky-stop-at-el';


        this.stickyAccordionModeAttr = 'data-lf-position-sticky-accordion-mode';
        this.accordionCl = 'insurance__accordion__item';
        this.accordionOpenAttr = 'data-lf-accordion-open';

        setTimeout(() => this.setupEventListeners(), 350);
    }

    // if sticky is inside accordion, accordion has to be open in order for sticky to stick :)
    canBeActivated = (stickyEl) => {
        if (!stickyEl.hasAttribute(this.stickyAccordionModeAttr)) {
            return true;
        }

        let stickOnEl = document.getElementById(stickyEl.getAttribute(this.enableStickyAtElAttr));
        return stickOnEl.hasAttribute(this.accordionOpenAttr);
    };

    setupEventListeners = () => {
        let stickyEl = document.querySelector(this.stickySl);

        if (!stickyEl) {
            return;
        }

        let stickOnEl = document.getElementById(stickyEl.getAttribute(this.enableStickyAtElAttr)); 
        let stopAtEl = document.getElementById(stickyEl.getAttribute(this.disableStickyAtElAttr)); 

        let stickOnPosition = stickOnEl.getBoundingClientRect().top + (window.pageYOffset || 
            document.documentElement.scrollTop);
        
        let stopAt = stopAtEl 
            ? 
                stopAtEl.getBoundingClientRect().bottom + (window.pageYOffset || 
                document.documentElement.scrollTop) - stickyEl.scrollHeight 
            : 
                document.body.scrollHeight;

        // update sticky vertical break points on click 
        // (if content is inserted or an accordion is opened, the vertical start/stop position may change)
        
        window.addEventListener('click', () => {
            setTimeout(() => {
                if (window.innerWidth > definitions.breaks.small) {
                    return; 
                }

                stopAt = stopAtEl ? stopAtEl.getBoundingClientRect().bottom + (window.pageYOffset || 
                    document.documentElement.scrollTop) - stickyEl.scrollHeight : document.body.scrollHeight;

                stickOnPosition = stickOnEl.getBoundingClientRect().top + (window.pageYOffset || 
                    document.documentElement.scrollTop);
            }, 350);
        });

        // TODO: double check that touchmove is not needed
        ['scroll' /*, 'touchmove'*/].forEach(eventName => {
            window.addEventListener(eventName, () => {
                if (!this.canBeActivated(stickyEl) || window.innerWidth > definitions.breaks.small) {
                    return;
                } 

                if (!stickyEl.hasAttribute(this.stickyActiveAttr) && 
                    window.pageYOffset > stickOnPosition  && window.pageYOffset < stopAt) {
                        stickyEl.setAttribute(this.stickyActiveAttr, true);
                        stickyEl = document.body.insertBefore(stickyEl, null);
                }

                if(stickyEl.hasAttribute(this.stickyActiveAttr) && 
                    window.pageYOffset >= stopAt || window.pageYOffset <= stickOnPosition) {
                        stickyEl.removeAttribute(this.stickyActiveAttr);
                } 
            });
        });
    }

}